/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

import { toCamelCase } from 'lib/formatters/strings';

import { ATTRIBUTE_TYPES } from './attributes_constants';

export const ACTIVITY_STAT = 'ACTIVITY_STAT';
export const ATTRIBUTE = 'ATTRIBUTE';
export const FIELD = 'FIELD';
export const INCENTIVE = 'INCENTIVE';
export const OPT_IN_FORM = 'OPT_IN_FORM';
export const PARTICIPANT_LABEL = 'PARTICIPANT_LABEL';
export const PARTICIPANT_SOURCE = 'PARTICIPANT_SOURCE';
export const PROJECT = 'PROJECT';

export const OR_IS_NOT_SET_PARAM_KEY = toCamelCase(
  'or_is_not_set',
);

export const PARAM_TYPES = {
  ARRAY: 'array',
  BOOLEAN: 'boolean',
  DATE: 'date',
  DATE_TIME: 'date_time',
  DECIMAL: 'decimal',
  INTEGER: 'integer',
  TEXT: 'text',
};

export const OPERAND_TYPES = {
  ACTIVITY_STAT: 'Recruiting::Search::FilterOperands::ActivityStatOperand',
  FIELD: 'Recruiting::Search::FilterOperands::FieldOperand',
  INCENTIVE: 'Recruiting::Search::FilterOperands::IncentiveOperand',
  OPT_IN_FORM: 'Recruiting::Search::FilterOperands::OptInFormOperand',
  PARTICIPANT_LABEL: 'Recruiting::Search::FilterOperands::ParticipantLabelOperand',
  PARTICIPANT_SOURCE: 'Recruiting::Search::FilterOperands::ParticipantSourceOperand',
  POPULATION_ATTRIBUTE: 'Recruiting::Search::FilterOperands::AttributeOperand',
  PROJECT: 'Recruiting::Search::FilterOperands::ProjectOperand',
};

export const OPERAND_TYPE_LOOKUP = {
  
    activity_stat_date_before: 'Recruiting::Search::FilterOperands::ActivityStatOperand',
  
    activity_stat_date_after: 'Recruiting::Search::FilterOperands::ActivityStatOperand',
  
    activity_stat_date_less_than_days_ago: 'Recruiting::Search::FilterOperands::ActivityStatOperand',
  
    activity_stat_date_more_than_days_ago: 'Recruiting::Search::FilterOperands::ActivityStatOperand',
  
    activity_stat_date_is_set: 'Recruiting::Search::FilterOperands::ActivityStatOperand',
  
    activity_stat_date_is_not_set: 'Recruiting::Search::FilterOperands::ActivityStatOperand',
  
    boolean_is: 'Recruiting::Search::FilterOperands::AttributeOperand',
  
    boolean_is_set: 'Recruiting::Search::FilterOperands::AttributeOperand',
  
    boolean_is_not_set: 'Recruiting::Search::FilterOperands::AttributeOperand',
  
    date_before: 'Recruiting::Search::FilterOperands::AttributeOperand',
  
    date_after: 'Recruiting::Search::FilterOperands::AttributeOperand',
  
    date_less_than_days_ago: 'Recruiting::Search::FilterOperands::AttributeOperand',
  
    date_more_than_days_ago: 'Recruiting::Search::FilterOperands::AttributeOperand',
  
    date_is_set: 'Recruiting::Search::FilterOperands::AttributeOperand',
  
    date_is_not_set: 'Recruiting::Search::FilterOperands::AttributeOperand',
  
    decimal_equals: 'Recruiting::Search::FilterOperands::AttributeOperand',
  
    decimal_does_not_equal: 'Recruiting::Search::FilterOperands::AttributeOperand',
  
    decimal_greater_than: 'Recruiting::Search::FilterOperands::AttributeOperand',
  
    decimal_greater_than_or_equal_to: 'Recruiting::Search::FilterOperands::AttributeOperand',
  
    decimal_less_than: 'Recruiting::Search::FilterOperands::AttributeOperand',
  
    decimal_less_than_or_equal_to: 'Recruiting::Search::FilterOperands::AttributeOperand',
  
    decimal_is_set: 'Recruiting::Search::FilterOperands::AttributeOperand',
  
    decimal_is_not_set: 'Recruiting::Search::FilterOperands::AttributeOperand',
  
    string_is: 'Recruiting::Search::FilterOperands::AttributeOperand',
  
    string_is_not: 'Recruiting::Search::FilterOperands::AttributeOperand',
  
    string_is_set: 'Recruiting::Search::FilterOperands::AttributeOperand',
  
    string_is_not_set: 'Recruiting::Search::FilterOperands::AttributeOperand',
  
    string_contains: 'Recruiting::Search::FilterOperands::AttributeOperand',
  
    string_does_not_contain: 'Recruiting::Search::FilterOperands::AttributeOperand',
  
    field_string_is: 'Recruiting::Search::FilterOperands::FieldOperand',
  
    field_string_is_not: 'Recruiting::Search::FilterOperands::FieldOperand',
  
    field_boolean_is: 'Recruiting::Search::FilterOperands::FieldOperand',
  
    field_date_before: 'Recruiting::Search::FilterOperands::FieldOperand',
  
    field_date_after: 'Recruiting::Search::FilterOperands::FieldOperand',
  
    field_date_less_than_days_ago: 'Recruiting::Search::FilterOperands::FieldOperand',
  
    field_date_more_than_days_ago: 'Recruiting::Search::FilterOperands::FieldOperand',
  
    field_date_is_set: 'Recruiting::Search::FilterOperands::FieldOperand',
  
    field_date_is_not_set: 'Recruiting::Search::FilterOperands::FieldOperand',
  
    field_source_is: 'Recruiting::Search::FilterOperands::FieldOperand',
  
    field_source_is_not: 'Recruiting::Search::FilterOperands::FieldOperand',
  
    field_string_contains: 'Recruiting::Search::FilterOperands::FieldOperand',
  
    field_string_does_not_contain: 'Recruiting::Search::FilterOperands::FieldOperand',
  
    incentive_is: 'Recruiting::Search::FilterOperands::IncentiveOperand',
  
    incentive_is_not: 'Recruiting::Search::FilterOperands::IncentiveOperand',
  
    incentive_is_set: 'Recruiting::Search::FilterOperands::IncentiveOperand',
  
    incentive_is_not_set: 'Recruiting::Search::FilterOperands::IncentiveOperand',
  
    incentive_greater_than: 'Recruiting::Search::FilterOperands::IncentiveOperand',
  
    incentive_greater_than_or_equal_to: 'Recruiting::Search::FilterOperands::IncentiveOperand',
  
    incentive_less_than: 'Recruiting::Search::FilterOperands::IncentiveOperand',
  
    incentive_less_than_or_equal_to: 'Recruiting::Search::FilterOperands::IncentiveOperand',
  
    opt_in_form_is: 'Recruiting::Search::FilterOperands::OptInFormOperand',
  
    opt_in_form_is_not: 'Recruiting::Search::FilterOperands::OptInFormOperand',
  
    participant_label_has_any: 'Recruiting::Search::FilterOperands::ParticipantLabelOperand',
  
    participant_source_is: 'Recruiting::Search::FilterOperands::ParticipantSourceOperand',
  
    participant_source_is_not: 'Recruiting::Search::FilterOperands::ParticipantSourceOperand',
  
    project_participated_in: 'Recruiting::Search::FilterOperands::ProjectOperand',
  
    project_not_participated_in: 'Recruiting::Search::FilterOperands::ProjectOperand',
  
};



export const ACTIVITY_STAT_FILTER_OPERANDS = {
  [ATTRIBUTE_TYPES.DATE]: [
    
      {
        allowMultiple: false,
        display: 'Before',
        key: 'activity_stat_date_before',
        params: {"endAt":"date_time","orIsNotSet":"boolean"}
      },
    
      {
        allowMultiple: false,
        display: 'After',
        key: 'activity_stat_date_after',
        params: {"startAt":"date_time","orIsNotSet":"boolean"}
      },
    
      {
        allowMultiple: false,
        display: 'Less than',
        key: 'activity_stat_date_less_than_days_ago',
        params: {"days":{"attributes":{"min":0},"label":"days ago","type":"integer"},"orIsNotSet":"boolean"}
      },
    
      {
        allowMultiple: false,
        display: 'More than',
        key: 'activity_stat_date_more_than_days_ago',
        params: {"days":{"attributes":{"min":0},"label":"days ago","type":"integer"},"orIsNotSet":"boolean"}
      },
    
      {
        allowMultiple: false,
        display: 'Is set',
        key: 'activity_stat_date_is_set',
        params: {}
      },
    
      {
        allowMultiple: false,
        display: 'Is not set',
        key: 'activity_stat_date_is_not_set',
        params: {}
      },
    
  ],
};

export const FILTERABLE_ACTIVITY_STATS = {
  
    last_applied_at: { name: 'Last applied date', type: 'date' },
  
    last_invited_at: { name: 'Last invited date', type: 'date' },
  
    last_participated_at: { name: 'Last participated date', type: 'date' },
  
};









export const ATTRIBUTE_FILTER_OPERANDS = {
  [ATTRIBUTE_TYPES.BOOLEAN]: [
    
      {
        allowMultiple: false,
        display: 'Is',
        key: 'boolean_is',
        params: {"value":"boolean","orIsNotSet":"boolean"}
      },
    
      {
        allowMultiple: false,
        display: 'Is set',
        key: 'boolean_is_set',
        params: {}
      },
    
      {
        allowMultiple: false,
        display: 'Is not set',
        key: 'boolean_is_not_set',
        params: {}
      },
    
  ],
  [ATTRIBUTE_TYPES.DATE]: [
    
      {
        allowMultiple: false,
        display: 'Before',
        key: 'date_before',
        params: {"endDate":"date","orIsNotSet":"boolean"}
      },
    
      {
        allowMultiple: false,
        display: 'After',
        key: 'date_after',
        params: {"startDate":"date","orIsNotSet":"boolean"}
      },
    
      {
        allowMultiple: false,
        display: 'Less than days ago',
        key: 'date_less_than_days_ago',
        params: {"days":"integer","orIsNotSet":"boolean"}
      },
    
      {
        allowMultiple: false,
        display: 'More than days ago',
        key: 'date_more_than_days_ago',
        params: {"days":"integer","orIsNotSet":"boolean"}
      },
    
      {
        allowMultiple: false,
        display: 'Is set',
        key: 'date_is_set',
        params: {}
      },
    
      {
        allowMultiple: false,
        display: 'Is not set',
        key: 'date_is_not_set',
        params: {}
      },
    
  ],
  [ATTRIBUTE_TYPES.DECIMAL]: [
    
      {
        allowMultiple: true,
        display: 'Equals',
        key: 'decimal_equals',
        params: {"value":"decimal","orIsNotSet":"boolean"}
      },
    
      {
        allowMultiple: true,
        display: 'Does not equal',
        key: 'decimal_does_not_equal',
        params: {"value":"decimal"}
      },
    
      {
        allowMultiple: false,
        display: 'Greater than',
        key: 'decimal_greater_than',
        params: {"floor":"decimal","orIsNotSet":"boolean"}
      },
    
      {
        allowMultiple: false,
        display: 'Greater than or equal to',
        key: 'decimal_greater_than_or_equal_to',
        params: {"floor":"decimal","orIsNotSet":"boolean"}
      },
    
      {
        allowMultiple: false,
        display: 'Less than',
        key: 'decimal_less_than',
        params: {"ceiling":"decimal","orIsNotSet":"boolean"}
      },
    
      {
        allowMultiple: false,
        display: 'Less than or equal to',
        key: 'decimal_less_than_or_equal_to',
        params: {"ceiling":"decimal","orIsNotSet":"boolean"}
      },
    
      {
        allowMultiple: false,
        display: 'Is set',
        key: 'decimal_is_set',
        params: {}
      },
    
      {
        allowMultiple: false,
        display: 'Is not set',
        key: 'decimal_is_not_set',
        params: {}
      },
    
  ],
  [ATTRIBUTE_TYPES.SINGLE_SELECT]: [],
  [ATTRIBUTE_TYPES.SINGLE_SELECT_WITH_OTHER]: [],
  [ATTRIBUTE_TYPES.STRING]: [
    
      {
        allowMultiple: true,
        display: 'Is',
        key: 'string_is',
        params: {"value":"text","orIsNotSet":"boolean"}
      },
    
      {
        allowMultiple: true,
        display: 'Is not',
        key: 'string_is_not',
        params: {"value":"text"}
      },
    
      {
        allowMultiple: false,
        display: 'Is set',
        key: 'string_is_set',
        params: {}
      },
    
      {
        allowMultiple: false,
        display: 'Is not set',
        key: 'string_is_not_set',
        params: {}
      },
    
      {
        allowMultiple: true,
        display: 'Contains',
        key: 'string_contains',
        params: {"value":"text","orIsNotSet":"boolean"}
      },
    
      {
        allowMultiple: true,
        display: 'Does not contain',
        key: 'string_does_not_contain',
        params: {"value":"text"}
      },
    
  ],
  [ATTRIBUTE_TYPES.MULTI_SELECT]: [],
};











export const FILTERABLE_FIELDS = {
  
    
    created_at: { importable: false, name: 'Date added', type: 'date' },
  
    
    email: { importable: true, name: 'Email', type: 'string' },
  
    
    first_name: { importable: true, name: 'First name', type: 'string' },
  
    
    last_name: { importable: true, name: 'Last name', type: 'string' },
  
    
    phone_number: { importable: true, name: 'Phone number', type: 'string' },
  
    
    source: { importable: false, name: 'First source', type: 'integer' },
  
    
    unsubscribed: { importable: false, name: 'Unsubscribed', type: 'boolean' },
  
    
};

export const FIELD_FILTER_OPERANDS = {
  [ATTRIBUTE_TYPES.BOOLEAN]: [
    
      {
        allowMultiple: false,
        display: 'Is',
        key: 'field_boolean_is',
        params: {"value":"boolean"}
      },
    
  ],
  [ATTRIBUTE_TYPES.DATE] : [
    
      {
        allowMultiple: false,
        display: 'Before',
        key: 'field_date_before',
        params: {"value":"date_time"}
      },
    
      {
        allowMultiple: false,
        display: 'After',
        key: 'field_date_after',
        params: {"value":"date_time"}
      },
    
      {
        allowMultiple: false,
        display: 'Less than',
        key: 'field_date_less_than_days_ago',
        params: {"value":{"attributes":{"min":0},"label":"days ago","type":"integer"}}
      },
    
      {
        allowMultiple: false,
        display: 'More than',
        key: 'field_date_more_than_days_ago',
        params: {"value":{"attributes":{"min":0},"label":"days ago","type":"integer"}}
      },
    
      {
        allowMultiple: false,
        display: 'Is',
        key: 'field_date_is_set',
        params: {}
      },
    
      {
        allowMultiple: false,
        display: 'Is not set',
        key: 'field_date_is_not_set',
        params: {}
      },
    
  ],
  [ATTRIBUTE_TYPES.INTEGER] : [
    
      {
        allowMultiple: true,
        display: 'Is',
        key: 'field_source_is',
        params: {"value":"integer"},
      },
    
      {
        allowMultiple: true,
        display: 'Is not',
        key: 'field_source_is_not',
        params: {"value":"integer"},
      },
    
  ],
  [ATTRIBUTE_TYPES.STRING]: [
    
      {
        allowMultiple: true,
        display: 'Is',
        key: 'field_string_is',
        params: {"value":"text"}
      },
    
      {
        allowMultiple: true,
        display: 'Is not',
        key: 'field_string_is_not',
        params: {"value":"text"}
      },
    
      {
        allowMultiple: true,
        display: 'Contains',
        key: 'field_string_contains',
        params: {"value":"text"}
      },
    
      {
        allowMultiple: true,
        display: 'Does not contain',
        key: 'field_string_does_not_contain',
        params: {"value":"text"}
      },
    
  ],
};



export const FILTERABLE_INCENTIVES = {
  
    yearly_payment: { importable: false, name: 'Incentives earned', type: 'decimal' },
  
};

export const INCENTIVE_OPERANDS = {
  [ATTRIBUTE_TYPES.DECIMAL]: [
    
    {
      allowMultiple: false,
      display: 'Is',
      key: 'incentive_is',
      params: {"value":{"attributes":{"min":0,"step":0.01},"type":"decimal"},"yearCeiling":"integer","yearFloor":"integer"}
    },
    
    {
      allowMultiple: false,
      display: 'Is not',
      key: 'incentive_is_not',
      params: {"value":{"attributes":{"min":0,"step":0.01},"type":"decimal"},"yearCeiling":"integer","yearFloor":"integer"}
    },
    
    {
      allowMultiple: false,
      display: 'Is set',
      key: 'incentive_is_set',
      params: {"yearCeiling":"integer","yearFloor":"integer"}
    },
    
    {
      allowMultiple: false,
      display: 'Is not set',
      key: 'incentive_is_not_set',
      params: {"yearCeiling":"integer","yearFloor":"integer"}
    },
    
    {
      allowMultiple: false,
      display: 'Greater than',
      key: 'incentive_greater_than',
      params: {"floor":{"attributes":{"min":0,"step":0.01},"type":"decimal"},"yearCeiling":"integer","yearFloor":"integer"}
    },
    
    {
      allowMultiple: false,
      display: 'Greater than or equal to',
      key: 'incentive_greater_than_or_equal_to',
      params: {"floor":{"attributes":{"min":0,"step":0.01},"type":"decimal"},"yearCeiling":"integer","yearFloor":"integer"}
    },
    
    {
      allowMultiple: false,
      display: 'Less than',
      key: 'incentive_less_than',
      params: {"ceiling":{"attributes":{"min":0,"step":0.01},"type":"decimal"},"yearCeiling":"integer","yearFloor":"integer"}
    },
    
    {
      allowMultiple: false,
      display: 'Less than or equal to',
      key: 'incentive_less_than_or_equal_to',
      params: {"ceiling":{"attributes":{"min":0,"step":0.01},"type":"decimal"},"yearCeiling":"integer","yearFloor":"integer"}
    },
    
  ],
};

export const OPT_IN_FORM_OPERANDS = [
  
  {
    allowMultiple: true,
    display: 'Has completed',
    key: 'opt_in_form_is',
    params: {"ids":{"type":"array","items":{"type":"integer"}}}
  },
  
  {
    allowMultiple: true,
    display: 'Has not completed',
    key: 'opt_in_form_is_not',
    params: {"ids":{"type":"array","items":{"type":"integer"}}}
  },
  
];

export const PARTICIPANT_LABEL_OPERANDS = [
  
  {
    allowMultiple: false,
    display: 'Labels',
    key: 'participant_label_has_any',
    params: {"ids":{"type":"array","items":{"type":"integer"}}}
  },
  
];

export const PARTICIPANT_SOURCE_OPERANDS = [
  
  {
    allowMultiple: true,
    display: 'Participant source',
    key: 'participant_source_is',
    params: {"type":"text","ids":{"type":"array","items":{"type":"integer"}}}
  },
  
  {
    allowMultiple: true,
    display: 'Participant source is not',
    key: 'participant_source_is_not',
    params: {"type":"text","ids":{"type":"array","items":{"type":"integer"}}}
  },
  
];

export const PROJECT_OPERANDS = [
  
  {
    allowMultiple: true,
    display: 'Participated in',
    key: 'project_participated_in',
    params: {"projectId":"integer","reviewTierIds":{"type":"array","items":{"type":"integer"}},"statusIds":{"type":"array","items":{"type":"integer"}}}
  },
  
  {
    allowMultiple: true,
    display: 'Did not participate in',
    key: 'project_not_participated_in',
    params: {"projectId":"integer","reviewTierIds":{"type":"array","items":{"type":"integer"}},"statusIds":{"type":"array","items":{"type":"integer"}}}
  },
  
];

export const INCENTIVE_IS_NOT_SET_OPERAND = 'incentive_is_not_set';
export const INCENTIVE_IS_SET_OPERAND = 'incentive_is_set';

export const POPULATION_ATTRIBUTE_IS_NOT_SET_OPERANDS = Object.keys(ATTRIBUTE_FILTER_OPERANDS).reduce((acc, current) => {
  acc[current] = `${current}_is_not_set`;
  return acc;
}, {} as any);

export const POPULATION_ATTRIBUTE_IS_SET_OPERANDS = Object.keys(ATTRIBUTE_FILTER_OPERANDS).reduce((acc, current) => {
  acc[current] = `${current}_is_set`;
  return acc;
}, {} as any);
